<!--
 * @Description: 列表数据分页组件
 * @version:
 * @Author: knight
 * @Date: 2021-10-23 16:49:29
 * @LastEditors: knight
 * @LastEditTime: 2022-02-09 17:45:14
-->
<template>
  <div>
    <div v-if="!dataSource.length && !loading" class="infinite-no-data">
      <img :src="require('@/assets/images/mine_bg.png')" />
    </div>
    <ul
      :class="listClass"
      v-if="dataSource.length"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <slot name="list" :list="dataSource" v-if="dataSource.length" ></slot>
    </ul>
    <p v-if="loading" class="infinite-loading">
      <mt-spinner type="fading-circle" :size="24" color="#999"></mt-spinner>
      <span class="txt">加载中...</span>
    </p>
    <p class="infinite-no-more" v-if="!more && dataSource.length">
      <span>—— 没有更多内容了 ——</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    autoRequest: {
      type: Boolean,
      default: true,
    },
    listClass: {
      type: String,
    },
    // 列表数据请求路径
    road: {
      type: String,
      required: true,
    },
    listData: {
      type: Object,
    },
    // 请求参数
    params: {
      type: Object,
    },
    // 数据请求回调
    callback: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      loading: false,
      more: true,
      dataSource: [],
      noData: false,
      paging: {
        page: 1,
        total: 0,
        totalPage: 0,
      },
    };
  },
  watch: {
    params: {
      handler() {
        this.onRefresh();
      },
      deep: true,
    },
    page() {
      this.getDataSource();
    },
  },
  mounted() {
    if (this.listData?.list?.length) {
      this.handleListData(this.listData);
    } else {
      this.autoRequest && this.road && this.getDataSource();
    }
  },
  methods: {
    loadMore() {
      if (this.more) {
        this.page += 1;
     }
    },
    // 初始化
    onRefresh() {
      // console.log('父组件中被调用');
      this.page = 1;
      this.more = true;
      this.noData = false;
      setTimeout(() => {
        this.getDataSource();
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page = val;
    },
    // 每页显示条目个数改变
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 获取列表数据
    getDataSource() {
      if (this.loading) return;
      this.loading = true;
      const query = {
        ...this.params,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$get({ road: this.road, query })
        .then(res => {
          if (res.code === 0) {
            const data = res.data;
            // console.log(data)
            this.handleListData(data);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理列表数据
    handleListData(data) {
      const page = this.page;
      const pageSize = this.pageSize;
      const list = data.list || [];
      const total = (data?.total || 0) - 0;
      // console.log(this.page)
      this.dataSource = this.page === 1 ? list : this.dataSource.concat(list);
      // console.log(this.dataSource)
      this.paging = {
        page: data?.page,
        total,
        totalPage: data.total_page || Math.ceil(total / pageSize),
      };
      if (pageSize * (page - 1) + list.length === total) {
        this.more = false;
      } else {
        this.more = true;
      }
      this.noData = !total;
      if (this.callback) {
        this.callback();
      }
    },
  },
};
</script>

<style lang="less">
.layout-list {
  margin-left: -10px;
  margin-right: -10px;
  min-height: 400px;
}
.layout-list-item {
  display: inline-block;
  vertical-align: top;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
}
.infinite-no-data {
  margin-top: 20px;
}
.pagination-wrapper {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
